// extracted by mini-css-extract-plugin
export var downArrow = "_as-0";
export var infoTooltipIcon = "_as-3";
export var label = "_as-1";
export var optionCard = "_as-4";
export var upArrow = "_as-2";